"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureLogin = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

var _ModalContainer = _interopRequireDefault(require("@react/react-spectrum/ModalContainer"));

var _Dialog = _interopRequireDefault(require("@react/react-spectrum/Dialog"));

var _LoginForm = _interopRequireDefault(require("./LoginForm"));

var _Root = _interopRequireDefault(require("../../wrappers/Root"));

var _context = require("../../actions/context");

var _constants = require("../../constants");

var _useIngest2 = _interopRequireDefault(require("../../hooks/useIngest"));

var _CallbackContext = _interopRequireDefault(require("../../context/CallbackContext"));

var _Login = _interopRequireDefault(require("./Login.scss"));

var _reducers = require("../../reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var loginWrapperId = "".concat(_constants.PREFIX, "-login-wrapper");
/**
 * Renders a modal dialog imperatively via `ModalContainer.show()`.
 * `ModalContainer.show()` requires a context and/or a container
 * instance in order to find the closest React Spectrum provider
 * and this was written to workaround that (in this case, it'll try
 * to find the closest Provider from Modal itself).
 *
 * TODO: Probably could remove this when we move to Spectrum v3.
 *
 * @return {ReactElement} an empty div
 */

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  /**
   * Constructor.
   * @param {Object} props - props
   */
  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    if (!document.getElementById("".concat(loginWrapperId))) {
      _this.loginWrapper = document.createElement('div');

      _this.loginWrapper.setAttribute('id', loginWrapperId);
    }

    return _this;
  }
  /**
   * Show the modal
   * @returns {undefined}
   */


  _createClass(Modal, [{
    key: "_show",
    value: function _show() {
      this.modalKey = _ModalContainer.default.show(this.props.children, this, this.loginWrapper.querySelector('.react-spectrum-provider'));
      document.body.appendChild(this.loginWrapper);
    }
    /**
     * Show the modal
     * @returns {undefined}
     */

  }, {
    key: "_hide",
    value: function _hide() {
      _ModalContainer.default.hide(this.modalKey);

      if (this.loginWrapper) {
        this.loginWrapper.parentNode.removeChild(this.loginWrapper);
      }
    }
    /**
     * Lifecycle method invoked when mounting the component for the first time.
     * @return {undefined}
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._show();
    }
    /**
     * Lifecyle function for unmounting.
     * @returns {undefined}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._hide();
    }
    /**
     * React Spectrum modals have an issue updating content once rendered
     * @returns {undefined}
     */

  }, {
    key: "refreshView",
    value: function refreshView() {
      this._hide();

      this._show();
    }
    /**
     * Lifecycle method for rendering.
     * @return {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      return this.loginWrapper ? /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_Root.default, null), this.loginWrapper) : null;
    }
  }]);

  return Modal;
}(_react.default.Component);

Modal.propTypes = {
  children: _propTypes.default.node.isRequired
};

var Login = function Login(_ref) {
  var beforeLogin = _ref.beforeLogin,
      createGuestUserSession = _ref.createGuestUserSession,
      guestSessionState = _ref.guestSessionState,
      intl = _ref.intl,
      onGuestLogin = _ref.onGuestLogin,
      onLoginCancel = _ref.onLoginCancel,
      reCaptchaEnabled = _ref.reCaptchaEnabled,
      reCaptchaSiteKey = _ref.reCaptchaSiteKey,
      resetGuestUserSession = _ref.resetGuestUserSession,
      setGuestUserLoginToast = _ref.setGuestUserLoginToast,
      show = _ref.show,
      spectrumUIScale = _ref.spectrumUIScale,
      theme = _ref.theme;

  var _useIngest = (0, _useIngest2.default)(),
      fireEvent = _useIngest.fireEvent;

  var _useContext = (0, _react.useContext)(_CallbackContext.default),
      onLogin = _useContext.onLogin;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      guestName = _useState2[0],
      setGuestName = _useState2[1];

  var modalRef = (0, _react.useRef)();

  var fireIngestEvent = function fireIngestEvent(payload, immediately) {
    var ingestPayload = _objectSpread({}, payload);

    if (guestSessionState === 'expires-soon' || guestSessionState === 'expired') {
      (0, _lodash2.default)(ingestPayload, {
        user: {
          service_code: 'guest',
          service_level: guestSessionState === 'expires-soon' ? 'restore-guest' : 'expired-guest'
        }
      });
    }

    return fireEvent(ingestPayload, immediately);
  };

  var handleGuestLogin = function handleGuestLogin(guestUserInfo, isRestoringGuestSession) {
    beforeLogin();
    createGuestUserSession(guestUserInfo, isRestoringGuestSession).then(function (guestUserData) {
      fireIngestEvent({
        event: {
          subcategory: 'sign-in-guest',
          subtype: 'sign-in',
          type: 'click'
        }
      });
      onLogin(false, _objectSpread(_objectSpread({}, guestUserData), {}, {
        name: guestUserInfo.userName
      }));
      onGuestLogin(!guestSessionState);

      if (!isRestoringGuestSession) {
        setGuestName(guestUserInfo.userName);
        setGuestUserLoginToast({
          toastType: 'success',
          toastMessageId: 'comments.submit.comment_as_guest_login_success',
          guestInfo: _objectSpread(_objectSpread({}, guestUserData), {}, {
            name: guestUserInfo.userName
          })
        });
      }
    }).catch(function (err) {
      fireIngestEvent({
        event: {
          subcategory: 'sign-in-guest',
          subtype: 'sign-in',
          type: 'click',
          error_code: err.status,
          error_type: err.message,
          error_desc: 'failed-to-create-guest-session'
        }
      });
      setGuestUserLoginToast({
        toastType: 'error',
        toastMessageId: 'comments.submit.comment_as_guest_login_error'
      });
      resetGuestUserSession();
      onLogin(false);
    });
  };

  var handleLogin = function handleLogin() {
    beforeLogin();
    fireIngestEvent({
      event: {
        subcategory: 'sign-in',
        subtype: 'sign-in',
        type: 'click'
      }
    }, true).then(function () {
      return onLogin(true);
    }).catch(function () {
      return onLogin(true);
    });
  };

  var handleLoginCancel = (0, _react.useCallback)(function () {
    onLoginCancel();

    if (guestSessionState === 'expires-soon') {
      resetGuestUserSession();
      onLogin(false);
    }
  }, [onLoginCancel, guestSessionState, resetGuestUserSession, onLogin]);
  (0, _react.useEffect)(function () {
    if (modalRef.current && guestSessionState === 'expired') {
      modalRef.current && modalRef.current.refreshView();
      onLogin && onLogin(false);
    }
  }, [guestSessionState, onLogin]);
  var wrapperClasses = "".concat(_Login.default.component, " ").concat(theme, "-theme ").concat(spectrumUIScale, "-scale");
  return show && /*#__PURE__*/_react.default.createElement(Modal, {
    ref: modalRef
  }, /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    id: "login-dialog",
    backdropClickable: true,
    className: wrapperClasses,
    isDismissible: true,
    modalContent: true,
    onClose: handleLoginCancel,
    title: intl.formatMessage({
      id: 'comments.login.title'
    }),
    trapFocus: true
  }, /*#__PURE__*/_react.default.createElement(_LoginForm.default, {
    existingGuestName: guestName,
    fireIngestEvent: fireIngestEvent,
    guestSessionState: guestSessionState,
    intl: intl,
    onGuestLogin: handleGuestLogin,
    onLogin: handleLogin,
    reCaptchaEnabled: reCaptchaEnabled,
    reCaptchaSiteKey: reCaptchaSiteKey
  })));
};

Login.defaultProps = {
  beforeLogin: function beforeLogin() {},
  onGuestLogin: function onGuestLogin() {},
  onLoginCancel: function onLoginCancel() {},
  show: false,
  spectrumUIScale: 'medium',
  theme: 'light'
};
Login.propTypes = {
  beforeLogin: _propTypes.default.func,
  createGuestUserSession: _propTypes.default.func.isRequired,
  guestSessionState: _propTypes.default.string,
  intl: _propTypes.default.object,
  onGuestLogin: _propTypes.default.func,
  onLoginCancel: _propTypes.default.func,
  reCaptchaEnabled: _propTypes.default.bool,
  reCaptchaSiteKey: _propTypes.default.string,
  resetGuestUserSession: _propTypes.default.func,
  setGuestUserLoginToast: _propTypes.default.func.isRequired,
  show: _propTypes.default.bool,
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  theme: _propTypes.default.oneOf(['light', 'lightest', 'dark', 'darkest'])
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    guestSessionState: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.guestSessionState"))
  };
};

var mapDispatchToProps = {
  createGuestUserSession: _context.contextCreateGuestUserSession,
  resetGuestUserSession: _context.contextResetGuestUserSession,
  setGuestUserLoginToast: _context.contextSetGuestUserLoginToastInfo
};
var withIntl = (0, _reactIntl.injectIntl)(Login);
exports.PureLogin = withIntl;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
})(withIntl);

exports.default = _default;